var path = 'public/app/features/dashboard/timepicker/settings.html';
var html = "<div class=editor-row>\n<div class=gf-form-group>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">Auto-refresh</span>\n\t\t<input type=text class=\"gf-form-input max-width-25\" ng-model=ctrl.panel.refresh_intervals array-join>\n\t</div>\n\t<div class=gf-form>\n\t\t<span class=\"gf-form-label width-10\">Now delay now-</span>\n\t\t<input type=text class=\"gf-form-input max-width-25\" ng-model=ctrl.panel.nowDelay placeholder=0m valid-time-span bs-tooltip=\"'Enter 1m to ignore the last minute (because it can contain incomplete metrics)'\" data-placement=right>\n\t</div>\n</div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/features/dashboard/timepicker/settings.html
// module id = 582
// module chunks = 5